/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 * Регенерируется из src/funnels/experiments/web_*.ts: `npm run generate-experiments-registry`.
 * Добавить эксперимент = создать src/funnels/experiments/web_<name>.ts с нужными appArea-ключами.
 * Удалить = git rm этого файла. Реестр подтянется автоматически (вшит в prebuild/lint/prepare).
 */
import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_activity_f_fasting_paywall from './experiments/web_activity_f_fasting_paywall'
import web_add_more_plans_to_program from './experiments/web_add_more_plans_to_program'
import web_auto_checkout from './experiments/web_auto_checkout'
import web_autotest_female_funnel_check from './experiments/web_autotest_female_funnel_check'
import web_before_after_start from './experiments/web_before_after_start'
import web_br_pricing_unification from './experiments/web_br_pricing_unification'
import web_chair_workouts_large_checkout from './experiments/web_chair_workouts_large_checkout'
import web_chair_yoga_gs_adapted_for_senior_audiences from './experiments/web_chair_yoga_gs_adapted_for_senior_audiences'
import web_compliance_jun_2026 from './experiments/web_compliance_jun_2026'
import web_discount_banner from './experiments/web_discount_banner'
import web_en_countries_price_optimization from './experiments/web_en_countries_price_optimization'
import web_eu_pricing_unification_g1 from './experiments/web_eu_pricing_unification_g1'
import web_eu_pricing_unification_g2 from './experiments/web_eu_pricing_unification_g2'
import web_eu_sales_tax from './experiments/web_eu_sales_tax'
import web_f_tai_chi_walking_v2_al_bmi_post_funnel from './experiments/web_f_tai_chi_walking_v2_al_bmi_post_funnel'
import web_fallback_loose_chance from './experiments/web_fallback_loose_chance'
import web_fallback_on_payment_male_eu from './experiments/web_fallback_on_payment_male_eu'
import web_fallback_on_payment_male_row from './experiments/web_fallback_on_payment_male_row'
import web_fallback_on_payment_male_us from './experiments/web_fallback_on_payment_male_us'
import web_fasting_f_improve_copy from './experiments/web_fasting_f_improve_copy'
import web_fasting_f_paywall_before_after from './experiments/web_fasting_f_paywall_before_after'
import web_fasting_f_personalized_coupon from './experiments/web_fasting_f_personalized_coupon'
import web_fasting_f_welcome_topic from './experiments/web_fasting_f_welcome_topic'
import web_fasting_fem_ai_coach_meal_plan from './experiments/web_fasting_fem_ai_coach_meal_plan'
import web_fasting_postmenopausal from './experiments/web_fasting_postmenopausal'
import web_feedback_with_social_proof from './experiments/web_feedback_with_social_proof'
import web_female_tai_chi_walking_v2_de from './experiments/web_female_tai_chi_walking_v2_de'
import web_female_tai_chi_walking_v2_fr from './experiments/web_female_tai_chi_walking_v2_fr'
import web_female_walking_sound_effects from './experiments/web_female_walking_sound_effects'
import web_large_paywall_update from './experiments/web_large_paywall_update'
import web_less_sleep_more_calories from './experiments/web_less_sleep_more_calories'
import web_m_chair_fitness_age from './experiments/web_m_chair_fitness_age'
import web_main_16_8_fasting from './experiments/web_main_16_8_fasting'
import web_main_tai_chi_walking_list_age_gender from './experiments/web_main_tai_chi_walking_list_age_gender'
import web_main_walking_adapted_first_screen_by_utm from './experiments/web_main_walking_adapted_first_screen_by_utm'
import web_male_chair_tai_chi_seated from './experiments/web_male_chair_tai_chi_seated'
import web_male_paywall_redesign from './experiments/web_male_paywall_redesign'
import web_ml_price_prediction from './experiments/web_ml_price_prediction'
import web_ml_price_prediction_high_wtp_i2_1 from './experiments/web_ml_price_prediction_high_wtp_i2_1'
import web_ml_price_prediction_high_wtp_i2_2 from './experiments/web_ml_price_prediction_high_wtp_i2_2'
import web_paywall_with_social_proof from './experiments/web_paywall_with_social_proof'
import web_pix_payment_method_for_br from './experiments/web_pix_payment_method_for_br'
import web_planpicker_save_w_checkout_update from './experiments/web_planpicker_save_w_checkout_update'
import web_price_before_scratch_small_funnels from './experiments/web_price_before_scratch_small_funnels'
import web_pricing_au_dk_se_ch from './experiments/web_pricing_au_dk_se_ch'
import web_redirect_simple_moves from './experiments/web_redirect_simple_moves'
import web_refactor_result_complete from './experiments/web_refactor_result_complete'
import web_remove_1_week_from_plans from './experiments/web_remove_1_week_from_plans'
import web_reprice_upsells_nonus from './experiments/web_reprice_upsells_nonus'
import web_show_2_plans from './experiments/web_show_2_plans'
import web_small_fallback_paywall from './experiments/web_small_fallback_paywall'
import web_sunday_offer_landing from './experiments/web_sunday_offer_landing'
import web_sunday_offer_paywall from './experiments/web_sunday_offer_paywall'
import web_tai_chi_al_paywall_plan_benefits from './experiments/web_tai_chi_al_paywall_plan_benefits'
import web_tai_chi_al_risk_free_offer from './experiments/web_tai_chi_al_risk_free_offer'
import web_tai_chi_female_v2_moto_block from './experiments/web_tai_chi_female_v2_moto_block'
import web_tai_chi_male_checkout_update from './experiments/web_tai_chi_male_checkout_update'
import web_tai_chi_walking_f_btn_color from './experiments/web_tai_chi_walking_f_btn_color'
import web_tai_chi_walking_walk_at_loader from './experiments/web_tai_chi_walking_walk_at_loader'
import web_tai_chi_yoga_m_glucose from './experiments/web_tai_chi_yoga_m_glucose'
import web_tai_chi_yoga_male_scratch_card from './experiments/web_tai_chi_yoga_male_scratch_card'
import web_unify_upsell_second_screen from './experiments/web_unify_upsell_second_screen'
import web_upsell_price_based_card_type from './experiments/web_upsell_price_based_card_type'
import web_upsell_supplements_peptides from './experiments/web_upsell_supplements_peptides'
import web_upsells_on_tai_chi from './experiments/web_upsells_on_tai_chi'
import web_walking_gs_indoor_intent from './experiments/web_walking_gs_indoor_intent'
import web_walking_gs_welcome_topic from './experiments/web_walking_gs_welcome_topic'
import web_walking_male_bulk_change from './experiments/web_walking_male_bulk_change'
import web_water_fasting_pr_guide from './experiments/web_water_fasting_pr_guide'
import web_welcome_for_applovin_tai_chi_walking from './experiments/web_welcome_for_applovin_tai_chi_walking'
import web_yoga_f_tai_chi_prices from './experiments/web_yoga_f_tai_chi_prices'
import web_yoga_female_scratch_card_before_the_paywall from './experiments/web_yoga_female_scratch_card_before_the_paywall'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	// Fasting
	'female': {
		web_add_more_plans_to_program,
		web_autotest_female_funnel_check,
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_discount_banner,
		web_eu_pricing_unification_g1,
		web_eu_sales_tax,
		web_fallback_loose_chance,
		web_fasting_f_improve_copy,
		web_fasting_f_paywall_before_after,
		web_fasting_f_personalized_coupon,
		web_fasting_f_welcome_topic,
		web_fasting_fem_ai_coach_meal_plan,
		web_fasting_postmenopausal,
		web_feedback_with_social_proof,
		web_ml_price_prediction_high_wtp_i2_1,
		web_ml_price_prediction_high_wtp_i2_2,
		web_pricing_au_dk_se_ch,
		web_reprice_upsells_nonus,
		web_small_fallback_paywall,
		web_sunday_offer_paywall,
		web_unify_upsell_second_screen,
	},
	'male': {
		web_compliance_jun_2026,
		web_en_countries_price_optimization,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_fallback_on_payment_male_us,
		web_male_paywall_redesign,
		web_price_before_scratch_small_funnels,
		web_sunday_offer_paywall,
		web_unify_upsell_second_screen,
	},
	'main': {
		web_before_after_start,
		web_main_16_8_fasting,
		web_sunday_offer_landing,
	},
	'female-water-fasting': {
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_eu_sales_tax,
		web_fallback_loose_chance,
		web_female_walking_sound_effects,
		web_pricing_au_dk_se_ch,
		web_reprice_upsells_nonus,
		web_unify_upsell_second_screen,
		web_water_fasting_pr_guide,
	},
	'male-water-fasting': {
		web_price_before_scratch_small_funnels,
	},
	'main-water-fasting': {},
	'female-pr': {},
	'male-pr': {},
	'main-pr': {},

	// Yoga
	'activity-female-yoga': {
		web_price_before_scratch_small_funnels,
		web_yoga_f_tai_chi_prices,
		web_yoga_female_scratch_card_before_the_paywall,
	},
	'activity-male-chair-workouts': {
		web_chair_workouts_large_checkout,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_fallback_on_payment_male_us,
		web_m_chair_fitness_age,
		web_male_paywall_redesign,
		web_paywall_with_social_proof,
		web_price_before_scratch_small_funnels,
	},
	'main-yoga': {
		web_chair_yoga_gs_adapted_for_senior_audiences,
	},

	// Walking
	'activity-female-walking': {
		web_activity_f_fasting_paywall,
		web_add_more_plans_to_program,
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_discount_banner,
		web_en_countries_price_optimization,
		web_eu_pricing_unification_g1,
		web_eu_sales_tax,
		web_fallback_loose_chance,
		web_female_walking_sound_effects,
		web_large_paywall_update,
		web_ml_price_prediction,
		web_planpicker_save_w_checkout_update,
		web_pricing_au_dk_se_ch,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_small_fallback_paywall,
		web_unify_upsell_second_screen,
		web_upsell_price_based_card_type,
		web_upsells_on_tai_chi,
	},
	'activity-female-walking-outdoor': {},
	'activity-female-nordic-walking-fwf': {},
	'activity-male-walking': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_fallback_on_payment_male_us,
		web_male_paywall_redesign,
		web_price_before_scratch_small_funnels,
		web_sunday_offer_paywall,
		web_unify_upsell_second_screen,
		web_upsell_price_based_card_type,
		web_upsells_on_tai_chi,
		web_walking_male_bulk_change,
	},
	'female-printable-walking': {},
	'activity-female-walking-japanese': {},
	'main-walking': {
		web_before_after_start,
		web_main_walking_adapted_first_screen_by_utm,
		web_walking_gs_indoor_intent,
		web_walking_gs_welcome_topic,
	},

	// Pilates
	'activity-female-pilates': {
		web_auto_checkout,
	},

	// Activity
	'activity-female-v2': {},
	'activity-male': {},
	'main-activity': {},

	// Tai Chi
	'activity-female-tai-chi': {},
	'activity-female-tai-chi-walking-v2': {
		web_activity_f_fasting_paywall,
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g2,
		web_eu_sales_tax,
		web_fallback_loose_chance,
		web_female_tai_chi_walking_v2_de,
		web_female_tai_chi_walking_v2_fr,
		web_less_sleep_more_calories,
		web_ml_price_prediction,
		web_pix_payment_method_for_br,
		web_planpicker_save_w_checkout_update,
		web_pricing_au_dk_se_ch,
		web_redirect_simple_moves,
		web_remove_1_week_from_plans,
		web_reprice_upsells_nonus,
		web_show_2_plans,
		web_sunday_offer_paywall,
		web_tai_chi_female_v2_moto_block,
		web_tai_chi_walking_f_btn_color,
		web_unify_upsell_second_screen,
		web_upsell_price_based_card_type,
		web_upsell_supplements_peptides,
		web_upsells_on_tai_chi,
	},
	'activity-female-tai-chi-walking-pr': {
		web_activity_f_fasting_paywall,
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g2,
		web_ml_price_prediction,
		web_pix_payment_method_for_br,
		web_redirect_simple_moves,
		web_refactor_result_complete,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_tai_chi_walking_f_btn_color,
		web_unify_upsell_second_screen,
		web_upsell_supplements_peptides,
		web_upsells_on_tai_chi,
	},
	'activity-female-chair-tai-chi-fwf': {},
	'activity-male-tai-chi-walking': {},
	'activity-male-tai-chi-yoga': {
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_fallback_on_payment_male_us,
		web_male_paywall_redesign,
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_male_scratch_card,
		web_upsells_on_tai_chi,
	},
	'activity-male-tai-chi-yoga-pr': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_female_walking_sound_effects,
		web_pix_payment_method_for_br,
		web_redirect_simple_moves,
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_m_glucose,
		web_tai_chi_yoga_male_scratch_card,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
	},
	'main-tai-chi': {},
	'main-tai-chi-pr': {},
	'main-tai-chi-walking': {
		web_main_tai_chi_walking_list_age_gender,
		web_sunday_offer_landing,
		web_tai_chi_walking_walk_at_loader,
	},
	'main-tai-chi-walking-pr': {},
	'activity-male-chair-tai-chi': {
		web_auto_checkout,
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_male_chair_tai_chi_seated,
		web_male_paywall_redesign,
		web_pricing_au_dk_se_ch,
		web_redirect_simple_moves,
	},
	'tai-chi-male-golfers-fwf': {},
	'main-chair-tai-chi-pr': {},

	// Calisthenics
	'activity-female-calisthenics': {},
	'activity-male-calisthenics': {},
	'main-calisthenics': {},
	'military-male': {},
	'activity-male-military-calisthenics': {
		web_redirect_simple_moves,
	},
	'activity-male-military-calisthenics-pr': {},
	'activity-female-military-calisthenics': {
		web_redirect_simple_moves,
	},
	'activity-female-military-calisthenics-pr': {},
	'main-military-calisthenics': {},
	'main-military-calisthenics-pr': {},

	// Diets
	'female-mediterranean-diet': {},
	'female-anti-inflammatory-diet': {},
	'female-hashimoto-diet': {},
	'female-ramadan-fwf': {},
	'carnivore-diet-gs': {},
	'carnivore-diet-male': {},
	'carnivore-diet-female': {},
	'japanese-diet': {},
	'male-japanese-diet': {},
	'female-japanese-diet': {},
	'female-korean-glow-diet': {},

	// AppLovin
	'main-tai-chi-walking-al': {},
	'activity-female-pilates-al': {},
	'activity-female-walking-al': {},
	'activity-male-tai-chi-yoga-al': {
		web_female_walking_sound_effects,
		web_price_before_scratch_small_funnels,
	},
	'activity-male-tai-chi-walking-al': {
		web_br_pricing_unification,
		web_female_walking_sound_effects,
		web_price_before_scratch_small_funnels,
	},
	'main-al': {},
	'female-al': {},
	'male-al': {},
	'activity-female-tai-chi-walking-v2-al': {
		web_before_after_start,
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_f_tai_chi_walking_v2_al_bmi_post_funnel,
		web_large_paywall_update,
		web_ml_price_prediction_high_wtp_i2_1,
		web_ml_price_prediction_high_wtp_i2_2,
		web_pix_payment_method_for_br,
		web_planpicker_save_w_checkout_update,
		web_redirect_simple_moves,
		web_refactor_result_complete,
		web_remove_1_week_from_plans,
		web_reprice_upsells_nonus,
		web_show_2_plans,
		web_small_fallback_paywall,
		web_tai_chi_al_paywall_plan_benefits,
		web_tai_chi_al_risk_free_offer,
		web_tai_chi_walking_f_btn_color,
		web_unify_upsell_second_screen,
		web_upsell_supplements_peptides,
		web_upsells_on_tai_chi,
		web_welcome_for_applovin_tai_chi_walking,
	},
	'female-water-fasting-al': {},
	'activity-male-chair-workouts-al': {},
	'activity-male-chair-tai-chi-al': {
		web_compliance_jun_2026,
		web_female_walking_sound_effects,
		web_ml_price_prediction,
		web_redirect_simple_moves,
	},
	'activity-female-chair-tai-chi-al-fwf': {},

	// Other
	'assessment': {},
	'together': {},
	'workbooks': {},
}

export default experimentsConfig
